import React from 'react'
import styled from 'styled-components'
import { scrollToId } from 'lib/scrollUtils'
import Pane from 'components/Common/Pane'
import { mediaQueryUp } from 'components/utils/breakpoint'
import OfferNavItem from 'components/OfferPage/OfferNavItem'

const NavWrapper = styled(Pane)`
  position: sticky;
  top: 0;
  overflow-x: auto;
  z-index: 2;

  ${mediaQueryUp.tablet} {
    overflow-x: visible;
  }
`

const Nav = styled.nav`
  text-align: center;
  white-space: nowrap;
`

const StyledNavItem = styled(OfferNavItem)`
  display: inline-block;
`

interface Props {
  magazineArticles: App.ContentMagazineArticlesState;
  contentFields: Array<App.HubPageContentFields>;
  shouldShowMagazineArticle: boolean;
}

function NavigableBar(props: Props) {
  return (
    <NavWrapper shadow>
      <Nav>
        {props.contentFields.map(contentField => (
          <StyledNavItem
            key={contentField.label}
            onClick={() => scrollToId(contentField.hash, -48)}
          >
            {contentField.label}
          </StyledNavItem>
        ))}
      </Nav>
    </NavWrapper>
  )
}

export default NavigableBar
